
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1a46"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1a46"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5zHp0", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $40f1e36cfb05f0f8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $40f1e36cfb05f0f8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $40f1e36cfb05f0f8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createLocalization = $40f1e36cfb05f0f8$var$createLocalization;

var $fYL7G = parcelRequire("fYL7G");

$40f1e36cfb05f0f8$var$__exportStar((parcelRequire("4D0ft")), module.exports);
function $40f1e36cfb05f0f8$var$createLocalization() {
    return new $fYL7G.PolyglotLocalizationImpl();
}

});
parcelRegister("fYL7G", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $ba2103425b5901fa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba2103425b5901fa$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ba2103425b5901fa$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ba2103425b5901fa$var$__createBinding(result, mod, k);
    }
    $ba2103425b5901fa$var$__setModuleDefault(result, mod);
    return result;
};
var $ba2103425b5901fa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PolyglotLocalizationImpl = void 0;

const $ba2103425b5901fa$var$node_polyglot_1 = $ba2103425b5901fa$var$__importDefault((parcelRequire("jfP1D")));

const $ba2103425b5901fa$var$messages = $ba2103425b5901fa$var$__importStar((parcelRequire("6qbLQ")));
/**
 * Implementation of Localization using node-polyglot.
 *
 * @see https://airbnb.io/polyglot.js/.
 */ class $ba2103425b5901fa$var$PolyglotLocalizationImpl {
    constructor(){
        this.polyglot = new $ba2103425b5901fa$var$node_polyglot_1.default({
            locale: "en",
            phrases: $ba2103425b5901fa$var$messages
        });
    }
    t(key) {
        return this.polyglot.t(key);
    }
}
module.exports.PolyglotLocalizationImpl = $ba2103425b5901fa$var$PolyglotLocalizationImpl;

});
parcelRegister("jfP1D", function(module, exports) {
//     (c) 2012-2018 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documentation:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//
"use strict";

var $lfuRA = parcelRequire("lfuRA");

var $lJ6Xf = parcelRequire("lJ6Xf");

var $ahFcW = parcelRequire("ahFcW");
var $e046ff9eb783e9b5$var$warn = function warn(message) {
    $lJ6Xf(false, message);
};
var $e046ff9eb783e9b5$var$defaultReplace = String.prototype.replace;
var $e046ff9eb783e9b5$var$split = String.prototype.split;
// #### Pluralization methods
// The string that separates the different phrase possibilities.
var $e046ff9eb783e9b5$var$delimiter = "||||";
var $e046ff9eb783e9b5$var$russianPluralGroups = function(n) {
    var lastTwo = n % 100;
    var end = lastTwo % 10;
    if (lastTwo !== 11 && end === 1) return 0;
    if (2 <= end && end <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) return 1;
    return 2;
};
var $e046ff9eb783e9b5$var$defaultPluralRules = {
    // Mapping from pluralization group plural logic.
    pluralTypes: {
        arabic: function(n) {
            // http://www.arabeyes.org/Plural_Forms
            if (n < 3) return n;
            var lastTwo = n % 100;
            if (lastTwo >= 3 && lastTwo <= 10) return 3;
            return lastTwo >= 11 ? 4 : 5;
        },
        bosnian_serbian: $e046ff9eb783e9b5$var$russianPluralGroups,
        chinese: function() {
            return 0;
        },
        croatian: $e046ff9eb783e9b5$var$russianPluralGroups,
        french: function(n) {
            return n >= 2 ? 1 : 0;
        },
        german: function(n) {
            return n !== 1 ? 1 : 0;
        },
        russian: $e046ff9eb783e9b5$var$russianPluralGroups,
        lithuanian: function(n) {
            if (n % 10 === 1 && n % 100 !== 11) return 0;
            return n % 10 >= 2 && n % 10 <= 9 && (n % 100 < 11 || n % 100 > 19) ? 1 : 2;
        },
        czech: function(n) {
            if (n === 1) return 0;
            return n >= 2 && n <= 4 ? 1 : 2;
        },
        polish: function(n) {
            if (n === 1) return 0;
            var end = n % 10;
            return 2 <= end && end <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        },
        icelandic: function(n) {
            return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;
        },
        slovenian: function(n) {
            var lastTwo = n % 100;
            if (lastTwo === 1) return 0;
            if (lastTwo === 2) return 1;
            if (lastTwo === 3 || lastTwo === 4) return 2;
            return 3;
        },
        romanian: function(n) {
            if (n === 1) return 0;
            var lastTwo = n % 100;
            if (n === 0 || lastTwo >= 2 && lastTwo <= 19) return 1;
            return 2;
        },
        ukrainian: $e046ff9eb783e9b5$var$russianPluralGroups
    },
    // Mapping from pluralization group to individual language codes/locales.
    // Will look up based on exact match, if not found and it's a locale will parse the locale
    // for language code, and if that does not exist will default to 'en'
    pluralTypeToLanguages: {
        arabic: [
            "ar"
        ],
        bosnian_serbian: [
            "bs-Latn-BA",
            "bs-Cyrl-BA",
            "srl-RS",
            "sr-RS"
        ],
        chinese: [
            "id",
            "id-ID",
            "ja",
            "ko",
            "ko-KR",
            "lo",
            "ms",
            "th",
            "th-TH",
            "zh"
        ],
        croatian: [
            "hr",
            "hr-HR"
        ],
        german: [
            "fa",
            "da",
            "de",
            "en",
            "es",
            "fi",
            "el",
            "he",
            "hi-IN",
            "hu",
            "hu-HU",
            "it",
            "nl",
            "no",
            "pt",
            "sv",
            "tr"
        ],
        french: [
            "fr",
            "tl",
            "pt-br"
        ],
        russian: [
            "ru",
            "ru-RU"
        ],
        lithuanian: [
            "lt"
        ],
        czech: [
            "cs",
            "cs-CZ",
            "sk"
        ],
        polish: [
            "pl"
        ],
        icelandic: [
            "is",
            "mk"
        ],
        slovenian: [
            "sl-SL"
        ],
        romanian: [
            "ro"
        ],
        ukrainian: [
            "uk",
            "ua"
        ]
    }
};
function $e046ff9eb783e9b5$var$langToTypeMap(mapping) {
    var ret = {};
    var mappingEntries = $lfuRA(mapping);
    for(var i = 0; i < mappingEntries.length; i += 1){
        var type = mappingEntries[i][0];
        var langs = mappingEntries[i][1];
        for(var j = 0; j < langs.length; j += 1)ret[langs[j]] = type;
    }
    return ret;
}
function $e046ff9eb783e9b5$var$pluralTypeName(pluralRules, locale) {
    var langToPluralType = $e046ff9eb783e9b5$var$langToTypeMap(pluralRules.pluralTypeToLanguages);
    return langToPluralType[locale] || langToPluralType[$e046ff9eb783e9b5$var$split.call(locale, /-/, 1)[0]] || langToPluralType.en;
}
function $e046ff9eb783e9b5$var$pluralTypeIndex(pluralRules, pluralType, count) {
    return pluralRules.pluralTypes[pluralType](count);
}
function $e046ff9eb783e9b5$var$createMemoizedPluralTypeNameSelector() {
    var localePluralTypeStorage = {};
    return function(pluralRules, locale) {
        var pluralType = localePluralTypeStorage[locale];
        if (pluralType && !pluralRules.pluralTypes[pluralType]) {
            pluralType = null;
            localePluralTypeStorage[locale] = pluralType;
        }
        if (!pluralType) {
            pluralType = $e046ff9eb783e9b5$var$pluralTypeName(pluralRules, locale);
            if (pluralType) localePluralTypeStorage[locale] = pluralType;
        }
        return pluralType;
    };
}
function $e046ff9eb783e9b5$var$escape(token) {
    return token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $e046ff9eb783e9b5$var$constructTokenRegex(opts) {
    var prefix = opts && opts.prefix || "%{";
    var suffix = opts && opts.suffix || "}";
    if (prefix === $e046ff9eb783e9b5$var$delimiter || suffix === $e046ff9eb783e9b5$var$delimiter) throw new RangeError('"' + $e046ff9eb783e9b5$var$delimiter + '" token is reserved for pluralization');
    return new RegExp($e046ff9eb783e9b5$var$escape(prefix) + "(.*?)" + $e046ff9eb783e9b5$var$escape(suffix), "g");
}
var $e046ff9eb783e9b5$var$memoizedPluralTypeName = $e046ff9eb783e9b5$var$createMemoizedPluralTypeNameSelector();
var $e046ff9eb783e9b5$var$defaultTokenRegex = /%\{(.*?)\}/g;
// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function $e046ff9eb783e9b5$var$transformPhrase(phrase, substitutions, locale, tokenRegex, pluralRules, replaceImplementation) {
    if (typeof phrase !== "string") throw new TypeError("Polyglot.transformPhrase expects argument #1 to be string");
    if (substitutions == null) return phrase;
    var result = phrase;
    var interpolationRegex = tokenRegex || $e046ff9eb783e9b5$var$defaultTokenRegex;
    var replace = replaceImplementation || $e046ff9eb783e9b5$var$defaultReplace;
    // allow number as a pluralization shortcut
    var options = typeof substitutions === "number" ? {
        smart_count: substitutions
    } : substitutions;
    // Select plural form: based on a phrase text that contains `n`
    // plural forms separated by `delimiter`, a `locale`, and a `substitutions.smart_count`,
    // choose the correct plural form. This is only done if `count` is set.
    if (options.smart_count != null && phrase) {
        var pluralRulesOrDefault = pluralRules || $e046ff9eb783e9b5$var$defaultPluralRules;
        var texts = $e046ff9eb783e9b5$var$split.call(phrase, $e046ff9eb783e9b5$var$delimiter);
        var bestLocale = locale || "en";
        var pluralType = $e046ff9eb783e9b5$var$memoizedPluralTypeName(pluralRulesOrDefault, bestLocale);
        var pluralTypeWithCount = $e046ff9eb783e9b5$var$pluralTypeIndex(pluralRulesOrDefault, pluralType, options.smart_count);
        result = $e046ff9eb783e9b5$var$defaultReplace.call(texts[pluralTypeWithCount] || texts[0], /^[^\S]*|[^\S]*$/g, "");
    }
    // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
    result = replace.call(result, interpolationRegex, function(expression, argument) {
        if (!$ahFcW(options, argument) || options[argument] == null) return expression;
        return options[argument];
    });
    return result;
}
// ### Polyglot class constructor
function $e046ff9eb783e9b5$var$Polyglot(options) {
    var opts = options || {};
    this.phrases = {};
    this.extend(opts.phrases || {});
    this.currentLocale = opts.locale || "en";
    var allowMissing = opts.allowMissing ? $e046ff9eb783e9b5$var$transformPhrase : null;
    this.onMissingKey = typeof opts.onMissingKey === "function" ? opts.onMissingKey : allowMissing;
    this.warn = opts.warn || $e046ff9eb783e9b5$var$warn;
    this.replaceImplementation = opts.replace || $e046ff9eb783e9b5$var$defaultReplace;
    this.tokenRegex = $e046ff9eb783e9b5$var$constructTokenRegex(opts.interpolation);
    this.pluralRules = opts.pluralRules || $e046ff9eb783e9b5$var$defaultPluralRules;
}
// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
$e046ff9eb783e9b5$var$Polyglot.prototype.locale = function(newLocale) {
    if (newLocale) this.currentLocale = newLocale;
    return this.currentLocale;
};
// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
$e046ff9eb783e9b5$var$Polyglot.prototype.extend = function(morePhrases, prefix) {
    var phraseEntries = $lfuRA(morePhrases || {});
    for(var i = 0; i < phraseEntries.length; i += 1){
        var key = phraseEntries[i][0];
        var phrase = phraseEntries[i][1];
        var prefixedKey = prefix ? prefix + "." + key : key;
        if (typeof phrase === "object") this.extend(phrase, prefixedKey);
        else this.phrases[prefixedKey] = phrase;
    }
};
// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
$e046ff9eb783e9b5$var$Polyglot.prototype.unset = function(morePhrases, prefix) {
    if (typeof morePhrases === "string") delete this.phrases[morePhrases];
    else {
        var phraseEntries = $lfuRA(morePhrases || {});
        for(var i = 0; i < phraseEntries.length; i += 1){
            var key = phraseEntries[i][0];
            var phrase = phraseEntries[i][1];
            var prefixedKey = prefix ? prefix + "." + key : key;
            if (typeof phrase === "object") this.unset(phrase, prefixedKey);
            else delete this.phrases[prefixedKey];
        }
    }
};
// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
$e046ff9eb783e9b5$var$Polyglot.prototype.clear = function() {
    this.phrases = {};
};
// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
$e046ff9eb783e9b5$var$Polyglot.prototype.replace = function(newPhrases) {
    this.clear();
    this.extend(newPhrases);
};
// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
$e046ff9eb783e9b5$var$Polyglot.prototype.t = function(key, options) {
    var phrase, result;
    var opts = options == null ? {} : options;
    if (typeof this.phrases[key] === "string") phrase = this.phrases[key];
    else if (typeof opts._ === "string") phrase = opts._;
    else if (this.onMissingKey) {
        var onMissingKey = this.onMissingKey;
        result = onMissingKey(key, opts, this.currentLocale, this.tokenRegex, this.pluralRules, this.replaceImplementation);
    } else {
        this.warn('Missing translation for key: "' + key + '"');
        result = key;
    }
    if (typeof phrase === "string") result = $e046ff9eb783e9b5$var$transformPhrase(phrase, opts, this.currentLocale, this.tokenRegex, this.pluralRules, this.replaceImplementation);
    return result;
};
// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
$e046ff9eb783e9b5$var$Polyglot.prototype.has = function(key) {
    return $ahFcW(this.phrases, key);
};
// export transformPhrase
$e046ff9eb783e9b5$var$Polyglot.transformPhrase = function transform(phrase, substitutions, locale) {
    return $e046ff9eb783e9b5$var$transformPhrase(phrase, substitutions, locale);
};
module.exports = $e046ff9eb783e9b5$var$Polyglot;

});
parcelRegister("lfuRA", function(module, exports) {
"use strict";

var $i3gRK = parcelRequire("i3gRK");

var $cov4E = parcelRequire("cov4E");

var $igGiT = parcelRequire("igGiT");

var $fWnZu = parcelRequire("fWnZu");

var $264vJ = parcelRequire("264vJ");
var $f782f0797ebbd94f$var$polyfill = $cov4E($fWnZu(), Object);
$i3gRK($f782f0797ebbd94f$var$polyfill, {
    getPolyfill: $fWnZu,
    implementation: $igGiT,
    shim: $264vJ
});
module.exports = $f782f0797ebbd94f$var$polyfill;

});
parcelRegister("i3gRK", function(module, exports) {
"use strict";

var $bW96R = parcelRequire("bW96R");
var $d2459705afbcd8f9$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $d2459705afbcd8f9$var$toStr = Object.prototype.toString;
var $d2459705afbcd8f9$var$concat = Array.prototype.concat;

var $gd1XA = parcelRequire("gd1XA");
var $d2459705afbcd8f9$var$isFunction = function(fn) {
    return typeof fn === "function" && $d2459705afbcd8f9$var$toStr.call(fn) === "[object Function]";
};

var $d2459705afbcd8f9$var$supportsDescriptors = (parcelRequire("3dZ0z"))();
var $d2459705afbcd8f9$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$d2459705afbcd8f9$var$isFunction(predicate) || !predicate()) return;
    }
    if ($d2459705afbcd8f9$var$supportsDescriptors) $gd1XA(object, name, value, true);
    else $gd1XA(object, name, value);
};
var $d2459705afbcd8f9$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $bW96R(map);
    if ($d2459705afbcd8f9$var$hasSymbols) props = $d2459705afbcd8f9$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$d2459705afbcd8f9$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$d2459705afbcd8f9$var$defineProperties.supportsDescriptors = !!$d2459705afbcd8f9$var$supportsDescriptors;
module.exports = $d2459705afbcd8f9$var$defineProperties;

});
parcelRegister("bW96R", function(module, exports) {
"use strict";
var $8b0c2d7acb21882c$var$slice = Array.prototype.slice;

var $kmzOx = parcelRequire("kmzOx");
var $8b0c2d7acb21882c$var$origKeys = Object.keys;

var $8b0c2d7acb21882c$var$keysShim = $8b0c2d7acb21882c$var$origKeys ? function keys(o) {
    return $8b0c2d7acb21882c$var$origKeys(o);
} : (parcelRequire("9WBvR"));
var $8b0c2d7acb21882c$var$originalKeys = Object.keys;
$8b0c2d7acb21882c$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($kmzOx(object)) return $8b0c2d7acb21882c$var$originalKeys($8b0c2d7acb21882c$var$slice.call(object));
            return $8b0c2d7acb21882c$var$originalKeys(object);
        };
    } else Object.keys = $8b0c2d7acb21882c$var$keysShim;
    return Object.keys || $8b0c2d7acb21882c$var$keysShim;
};
module.exports = $8b0c2d7acb21882c$var$keysShim;

});
parcelRegister("kmzOx", function(module, exports) {
"use strict";
var $ed31a4a84f4482c6$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $ed31a4a84f4482c6$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $ed31a4a84f4482c6$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("9WBvR", function(module, exports) {
"use strict";
var $73d6a11bdf0066a1$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $73d6a11bdf0066a1$var$has = Object.prototype.hasOwnProperty;
    var $73d6a11bdf0066a1$var$toStr = Object.prototype.toString;
    var $73d6a11bdf0066a1$var$isArgs = (parcelRequire("kmzOx")); // eslint-disable-line global-require
    var $73d6a11bdf0066a1$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $73d6a11bdf0066a1$var$hasDontEnumBug = !$73d6a11bdf0066a1$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $73d6a11bdf0066a1$var$hasProtoEnumBug = $73d6a11bdf0066a1$var$isEnumerable.call(function() {}, "prototype");
    var $73d6a11bdf0066a1$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $73d6a11bdf0066a1$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $73d6a11bdf0066a1$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $73d6a11bdf0066a1$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$73d6a11bdf0066a1$var$excludedKeys["$" + k] && $73d6a11bdf0066a1$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $73d6a11bdf0066a1$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $73d6a11bdf0066a1$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$73d6a11bdf0066a1$var$hasAutomationEqualityBug) return $73d6a11bdf0066a1$var$equalsConstructorPrototype(o);
        try {
            return $73d6a11bdf0066a1$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $73d6a11bdf0066a1$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $73d6a11bdf0066a1$var$toStr.call(object) === "[object Function]";
        var isArguments = $73d6a11bdf0066a1$var$isArgs(object);
        var isString = isObject && $73d6a11bdf0066a1$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $73d6a11bdf0066a1$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$73d6a11bdf0066a1$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $73d6a11bdf0066a1$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($73d6a11bdf0066a1$var$hasDontEnumBug) {
            var skipConstructor = $73d6a11bdf0066a1$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $73d6a11bdf0066a1$var$dontEnums.length; ++k)if (!(skipConstructor && $73d6a11bdf0066a1$var$dontEnums[k] === "constructor") && $73d6a11bdf0066a1$var$has.call(object, $73d6a11bdf0066a1$var$dontEnums[k])) theKeys.push($73d6a11bdf0066a1$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $73d6a11bdf0066a1$var$keysShim;

});


parcelRegister("gd1XA", function(module, exports) {
"use strict";

var $eacqQ = parcelRequire("eacqQ");

var $i6QkK = parcelRequire("i6QkK");

var $4xvdA = parcelRequire("4xvdA");

var $laYPK = parcelRequire("laYPK");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $4xvdA("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $4xvdA("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $4xvdA("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $4xvdA("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $4xvdA("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $4xvdA("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$laYPK && $laYPK(obj, property);
    if ($eacqQ) $eacqQ(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $i6QkK("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("eacqQ", function(module, exports) {
"use strict";

var $3cgqi = parcelRequire("3cgqi");
/** @type {import('.')} */ var $a4fba4999e96d52f$var$$defineProperty = $3cgqi("%Object.defineProperty%", true) || false;
if ($a4fba4999e96d52f$var$$defineProperty) try {
    $a4fba4999e96d52f$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $a4fba4999e96d52f$var$$defineProperty = false;
}
module.exports = $a4fba4999e96d52f$var$$defineProperty;

});
parcelRegister("3cgqi", function(module, exports) {
"use strict";
var $253f3b6225585fba$var$undefined1;

var $jvttj = parcelRequire("jvttj");

var $46giD = parcelRequire("46giD");

var $iYH2G = parcelRequire("iYH2G");

var $aX8Xm = parcelRequire("aX8Xm");

var $i6QkK = parcelRequire("i6QkK");

var $4xvdA = parcelRequire("4xvdA");

var $5j8v7 = parcelRequire("5j8v7");
var $253f3b6225585fba$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $253f3b6225585fba$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $253f3b6225585fba$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $253f3b6225585fba$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($253f3b6225585fba$var$$gOPD) try {
    $253f3b6225585fba$var$$gOPD({}, "");
} catch (e) {
    $253f3b6225585fba$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $253f3b6225585fba$var$throwTypeError = function() {
    throw new $4xvdA();
};
var $253f3b6225585fba$var$ThrowTypeError = $253f3b6225585fba$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $253f3b6225585fba$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $253f3b6225585fba$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $253f3b6225585fba$var$throwTypeError;
        }
    }
}() : $253f3b6225585fba$var$throwTypeError;

var $253f3b6225585fba$var$hasSymbols = (parcelRequire("gPmUh"))();

var $253f3b6225585fba$var$hasProto = (parcelRequire("aRN0t"))();
var $253f3b6225585fba$var$getProto = Object.getPrototypeOf || ($253f3b6225585fba$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $253f3b6225585fba$var$needsEval = {};
var $253f3b6225585fba$var$TypedArray = typeof Uint8Array === "undefined" || !$253f3b6225585fba$var$getProto ? undefined : $253f3b6225585fba$var$getProto(Uint8Array);
var $253f3b6225585fba$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $253f3b6225585fba$var$hasSymbols && $253f3b6225585fba$var$getProto ? $253f3b6225585fba$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $253f3b6225585fba$var$needsEval,
    "%AsyncGenerator%": $253f3b6225585fba$var$needsEval,
    "%AsyncGeneratorFunction%": $253f3b6225585fba$var$needsEval,
    "%AsyncIteratorPrototype%": $253f3b6225585fba$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $jvttj,
    "%eval%": eval,
    "%EvalError%": $46giD,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $253f3b6225585fba$var$$Function,
    "%GeneratorFunction%": $253f3b6225585fba$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $253f3b6225585fba$var$hasSymbols && $253f3b6225585fba$var$getProto ? $253f3b6225585fba$var$getProto($253f3b6225585fba$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$253f3b6225585fba$var$hasSymbols || !$253f3b6225585fba$var$getProto ? undefined : $253f3b6225585fba$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $iYH2G,
    "%ReferenceError%": $aX8Xm,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$253f3b6225585fba$var$hasSymbols || !$253f3b6225585fba$var$getProto ? undefined : $253f3b6225585fba$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $253f3b6225585fba$var$hasSymbols && $253f3b6225585fba$var$getProto ? $253f3b6225585fba$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $253f3b6225585fba$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $i6QkK,
    "%ThrowTypeError%": $253f3b6225585fba$var$ThrowTypeError,
    "%TypedArray%": $253f3b6225585fba$var$TypedArray,
    "%TypeError%": $4xvdA,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $5j8v7,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($253f3b6225585fba$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $253f3b6225585fba$var$errorProto = $253f3b6225585fba$var$getProto($253f3b6225585fba$var$getProto(e));
    $253f3b6225585fba$var$INTRINSICS["%Error.prototype%"] = $253f3b6225585fba$var$errorProto;
}
var $253f3b6225585fba$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $253f3b6225585fba$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $253f3b6225585fba$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $253f3b6225585fba$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $253f3b6225585fba$var$getProto) value = $253f3b6225585fba$var$getProto(gen.prototype);
    }
    $253f3b6225585fba$var$INTRINSICS[name] = value;
    return value;
};
var $253f3b6225585fba$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $4RNoh = parcelRequire("4RNoh");

var $ahFcW = parcelRequire("ahFcW");
var $253f3b6225585fba$var$$concat = $4RNoh.call(Function.call, Array.prototype.concat);
var $253f3b6225585fba$var$$spliceApply = $4RNoh.call(Function.apply, Array.prototype.splice);
var $253f3b6225585fba$var$$replace = $4RNoh.call(Function.call, String.prototype.replace);
var $253f3b6225585fba$var$$strSlice = $4RNoh.call(Function.call, String.prototype.slice);
var $253f3b6225585fba$var$$exec = $4RNoh.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $253f3b6225585fba$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $253f3b6225585fba$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $253f3b6225585fba$var$stringToPath = function stringToPath(string) {
    var first = $253f3b6225585fba$var$$strSlice(string, 0, 1);
    var last = $253f3b6225585fba$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $i6QkK("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $i6QkK("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $253f3b6225585fba$var$$replace(string, $253f3b6225585fba$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $253f3b6225585fba$var$$replace(subString, $253f3b6225585fba$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $253f3b6225585fba$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($ahFcW($253f3b6225585fba$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $253f3b6225585fba$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($ahFcW($253f3b6225585fba$var$INTRINSICS, intrinsicName)) {
        var value = $253f3b6225585fba$var$INTRINSICS[intrinsicName];
        if (value === $253f3b6225585fba$var$needsEval) value = $253f3b6225585fba$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $4xvdA("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $i6QkK("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $4xvdA("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $4xvdA('"allowMissing" argument must be a boolean');
    if ($253f3b6225585fba$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $i6QkK("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $253f3b6225585fba$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $253f3b6225585fba$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $253f3b6225585fba$var$$spliceApply(parts, $253f3b6225585fba$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $253f3b6225585fba$var$$strSlice(part, 0, 1);
        var last = $253f3b6225585fba$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $i6QkK("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($ahFcW($253f3b6225585fba$var$INTRINSICS, intrinsicRealName)) value = $253f3b6225585fba$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $4xvdA("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($253f3b6225585fba$var$$gOPD && i + 1 >= parts.length) {
                var desc = $253f3b6225585fba$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $ahFcW(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $253f3b6225585fba$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("jvttj", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("46giD", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("iYH2G", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aX8Xm", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("i6QkK", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("4xvdA", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("5j8v7", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("gPmUh", function(module, exports) {
"use strict";
var $c4032d944020f7cd$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $28r27 = parcelRequire("28r27");
module.exports = function hasNativeSymbols() {
    if (typeof $c4032d944020f7cd$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $c4032d944020f7cd$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $28r27();
};

});
parcelRegister("28r27", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("aRN0t", function(module, exports) {
"use strict";
var $7e94de51c6079f42$var$test = {
    __proto__: null,
    foo: {}
};
var $7e94de51c6079f42$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $7e94de51c6079f42$var$test
    }).foo === $7e94de51c6079f42$var$test.foo && !($7e94de51c6079f42$var$test instanceof $7e94de51c6079f42$var$$Object);
};

});

parcelRegister("4RNoh", function(module, exports) {
"use strict";

var $8wd1i = parcelRequire("8wd1i");
module.exports = Function.prototype.bind || $8wd1i;

});
parcelRegister("8wd1i", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $633b6958f9a70935$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $633b6958f9a70935$var$toStr = Object.prototype.toString;
var $633b6958f9a70935$var$max = Math.max;
var $633b6958f9a70935$var$funcType = "[object Function]";
var $633b6958f9a70935$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $633b6958f9a70935$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $633b6958f9a70935$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $633b6958f9a70935$var$toStr.apply(target) !== $633b6958f9a70935$var$funcType) throw new TypeError($633b6958f9a70935$var$ERROR_MESSAGE + target);
    var args = $633b6958f9a70935$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $633b6958f9a70935$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $633b6958f9a70935$var$concatty(args, arguments));
    };
    var boundLength = $633b6958f9a70935$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $633b6958f9a70935$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("ahFcW", function(module, exports) {
"use strict";
var $77cb74eaac05ee83$var$call = Function.prototype.call;
var $77cb74eaac05ee83$var$$hasOwn = Object.prototype.hasOwnProperty;

var $4RNoh = parcelRequire("4RNoh");
/** @type {import('.')} */ module.exports = $4RNoh.call($77cb74eaac05ee83$var$call, $77cb74eaac05ee83$var$$hasOwn);

});



parcelRegister("laYPK", function(module, exports) {
"use strict";

var $3cgqi = parcelRequire("3cgqi");
var $f6a9b8718c53e3c5$var$$gOPD = $3cgqi("%Object.getOwnPropertyDescriptor%", true);
if ($f6a9b8718c53e3c5$var$$gOPD) try {
    $f6a9b8718c53e3c5$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f6a9b8718c53e3c5$var$$gOPD = null;
}
module.exports = $f6a9b8718c53e3c5$var$$gOPD;

});


parcelRegister("3dZ0z", function(module, exports) {
"use strict";

var $eacqQ = parcelRequire("eacqQ");
var $2591e8f0ddabb47a$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$eacqQ;
};
$2591e8f0ddabb47a$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$eacqQ) return null;
    try {
        return $eacqQ([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $2591e8f0ddabb47a$var$hasPropertyDescriptors;

});


parcelRegister("cov4E", function(module, exports) {
"use strict";

var $4RNoh = parcelRequire("4RNoh");

var $3cgqi = parcelRequire("3cgqi");

var $6uyR1 = parcelRequire("6uyR1");

var $4xvdA = parcelRequire("4xvdA");
var $905fd493c3a13cd5$var$$apply = $3cgqi("%Function.prototype.apply%");
var $905fd493c3a13cd5$var$$call = $3cgqi("%Function.prototype.call%");
var $905fd493c3a13cd5$var$$reflectApply = $3cgqi("%Reflect.apply%", true) || $4RNoh.call($905fd493c3a13cd5$var$$call, $905fd493c3a13cd5$var$$apply);

var $eacqQ = parcelRequire("eacqQ");
var $905fd493c3a13cd5$var$$max = $3cgqi("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $4xvdA("a function is required");
    var func = $905fd493c3a13cd5$var$$reflectApply($4RNoh, $905fd493c3a13cd5$var$$call, arguments);
    return $6uyR1(func, 1 + $905fd493c3a13cd5$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $905fd493c3a13cd5$var$applyBind = function applyBind() {
    return $905fd493c3a13cd5$var$$reflectApply($4RNoh, $905fd493c3a13cd5$var$$apply, arguments);
};
if ($eacqQ) $eacqQ(module.exports, "apply", {
    value: $905fd493c3a13cd5$var$applyBind
});
else module.exports.apply = $905fd493c3a13cd5$var$applyBind;

});
parcelRegister("6uyR1", function(module, exports) {
"use strict";

var $3cgqi = parcelRequire("3cgqi");

var $gd1XA = parcelRequire("gd1XA");

var $013844769cbd24d4$var$hasDescriptors = (parcelRequire("3dZ0z"))();

var $laYPK = parcelRequire("laYPK");

var $4xvdA = parcelRequire("4xvdA");
var $013844769cbd24d4$var$$floor = $3cgqi("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $4xvdA("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $013844769cbd24d4$var$$floor(length) !== length) throw new $4xvdA("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $laYPK) {
        var desc = $laYPK(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($013844769cbd24d4$var$hasDescriptors) $gd1XA(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $gd1XA(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});


parcelRegister("igGiT", function(module, exports) {
"use strict";

var $3NYtP = parcelRequire("3NYtP");

var $gmOXS = parcelRequire("gmOXS");
var $d4ca894256047c8a$var$$isEnumerable = $gmOXS("Object.prototype.propertyIsEnumerable");
var $d4ca894256047c8a$var$$push = $gmOXS("Array.prototype.push");
module.exports = function entries(O) {
    var obj = $3NYtP(O);
    var entrys = [];
    for(var key in obj)if ($d4ca894256047c8a$var$$isEnumerable(obj, key)) $d4ca894256047c8a$var$$push(entrys, [
        key,
        obj[key]
    ]);
    return entrys;
};

});
parcelRegister("3NYtP", function(module, exports) {
"use strict";

var $4xvdA = parcelRequire("4xvdA");
/** @type {import('./RequireObjectCoercible')} */ module.exports = function RequireObjectCoercible(value) {
    if (value == null) throw new $4xvdA(arguments.length > 0 && arguments[1] || "Cannot call method on " + value);
    return value;
};

});

parcelRegister("gmOXS", function(module, exports) {
"use strict";

var $3cgqi = parcelRequire("3cgqi");

var $cov4E = parcelRequire("cov4E");
var $bea63bf09c625cd5$var$$indexOf = $cov4E($3cgqi("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $3cgqi(name, !!allowMissing);
    if (typeof intrinsic === "function" && $bea63bf09c625cd5$var$$indexOf(name, ".prototype.") > -1) return $cov4E(intrinsic);
    return intrinsic;
};

});


parcelRegister("fWnZu", function(module, exports) {
"use strict";

var $igGiT = parcelRequire("igGiT");
module.exports = function getPolyfill() {
    return typeof Object.entries === "function" ? Object.entries : $igGiT;
};

});

parcelRegister("264vJ", function(module, exports) {
"use strict";

var $fWnZu = parcelRequire("fWnZu");

var $i3gRK = parcelRequire("i3gRK");
module.exports = function shimEntries() {
    var polyfill = $fWnZu();
    $i3gRK(Object, {
        entries: polyfill
    }, {
        entries: function testEntries() {
            return Object.entries !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("lJ6Xf", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $fd1331f77253bd1a$var$__DEV__ = false;
var $fd1331f77253bd1a$var$warning = function() {};
if ($fd1331f77253bd1a$var$__DEV__) {
    var $fd1331f77253bd1a$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $fd1331f77253bd1a$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $fd1331f77253bd1a$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $fd1331f77253bd1a$var$warning;

});


parcelRegister("6qbLQ", function(module, exports) {
module.exports = JSON.parse('{"welcomeNote":{"title":"Welcome to the Petal Editor.","paragraph1":"You can edit the file and publish your changes by clicking the \'Publish File\' button.","paragraph2":"Your changes will be published to GitHub in your GitHub repository. After successful publication you will notified with a link to the PR. Happy editing!","buttonLabel":"Don\'t show again"},"resultNote":{"titleSuccess":"Your changes have been successfully published.","titleError":"Your changes could not be published.","paragraphSuccess":"You can check your published changes here: ","paragraphError":"Something went wrong with publishing your changes because of following error:"},"error":{"headlineDefault":"Sorry, something went wrong","headline1":"Sorry, something went wrong","headline2":"Sorry, something went wrong with your GitHub Authentication","bodyDefault":"No worries, you can simply close this page and reach out to the maintainers of the page if you need any assistance.","body1":"The file you are trying to edit could not be found and we don\'t know where to send you.","body2":"No worries, you can simply close this page and reach out to the maintainers of the page if you need any assistance.","body3":"The file you are trying to edit could not be found, because something is wrong with the parameters you provided. Please reach out to the maintainers of the page if you need any assistance.","body4":"You can click on the link below that will take you back to the file you were trying to edit.","body5":"It seems you have not been authenticated by GitHub.","body6":"Following error occurred: ","body7":"The file you are trying to edit could not be found.","body8":"Failed to load your file.","body9":"You could check your file and try again, or you can click on the link below to go back to the start page.","link1":"TODO: Content for \'messageKeys.error.link1\'","toastImageUpload":"Sorry, there was an error with uploading the image. Please check the image and try again.","toastImageInsert":"Sorry, something went wrong with inserting and saving the image.","toastFileUploadInvalid":"Sorry, there was an error with reading the file. Please check if the file you tried to upload contains valid xml and try again","toastFileUpload":"Sorry, something went wrong with opening the file","toastFileUploadNoInput":"Sorry, the editor has problems with opening the file","toastFileDownload":"Apologies, something went wrong in the editor to provide you the download.","toastGitHubPublishNoEditorState":"Sorry, it seems there is nothing in the editor to save and publish. Please try again.","toastGitHubUserEndpoint":"Sorry, an error occured while publishing the document. Please try again. The error: ","toastGitHubToken":"Sorry, an error occured while publishing the document. Please try again. The error: ","toastGitHubPR":"Sorry, an error occured while publishing the document. Please try again. The error: "}}');

});


parcelRegister("4D0ft", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



//# sourceMappingURL=index.5fec45f2.js.map
